import React from 'react';
import classNames from 'classnames';

import * as styles from './content-loader.scss';

interface ContentLoaderProps {
  width?: string | number;
  height?: string | number;
  style?: React.CSSProperties;
  animation?: boolean;
}

export const ContentLoader: React.FC<ContentLoaderProps> = ({
  width = '100%',
  height = '24px',
  style = {},
  animation = true
}) => (
  <div
    className={classNames(styles.customSkeleton, {
      [styles.animated]: animation
    })}
    style={{
      width,
      height,
      ...style
    }}
  />
);
